<template>
  <div>
    <notification-message class="notification" />
    <div v-if="room" class="parent layout">
      <!--Information of a room-->
      <div class="div1">
        <details-room
          :room="room"
          @redirectToPrevious="redirectToCenterDetails"
          :centerTooltip="centerTooltip"
          :desksAvailable="getDesksAvailable"
        />
      </div>
      <!--workplace list and room plan-->
      <div class="div2" style="margin-right: 2%">
        <div class="btn neumorphism-out plan-desks">
          <h2 class="list-item-title-place">
            {{ $t("crudDesks.plan") }}
          </h2>
          <div class="scrolling-plan">
            <PlanCanvas
              class="ml-3"
              ref="desksPlan"
              :shapes="desks"
              :config="planConfig"
              :editMode="false"
              canvasWidth="1200"
              canvasHeight="550"
            />
          </div>
        </div>
      </div>
      <div class="div3 btn neumorphism-out">
        <h2 class="list-item-title-place">
          {{ $t("crudDesks.title") }}
        </h2>
        <h3>
          {{ $t("crudDesks.desk") }}
        </h3>
        <desks-list
          ref="desksList"
          :room="room"
          :desks="desks"
          :planRef="$refs.desksPlan"
          :allDesks="allDesks"
          :editMode="false"
          :availableDesks="availableDesks"
          :bookInterval="bookInterval"
          :bookedDesks="bookedDesks"
          :getDesksAvailable="getDesksAvailable"
        />
        <h3>{{ $t("crudDesks.equipment") }}</h3>
        <desks-list
          :desks="desks"
          :planRef="$refs.desksPlan"
          :allDesks="allEquipments"
          :editMode="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mdiArrowCollapse, mdiAccountGroup, mdiDesk } from "@mdi/js";
import DesksList from "@/components/components-salles/admin//details/room/DesksList.vue";
import DetailsRoom from "@/components/components-salles/public/room/detail/DetailsRoom.vue";
import PlanCanvas from "@/components/components-salles/common/PlanCanvas";
import PlanAdminConfig from "@/models/plan/AdminConfig.json";
import PlanUserConfig from "@/models/plan/UserConfig.json";
import NotificationMessage from "../../components/components-base/notification/NotificationMessage.vue";
import { DateTime, Interval } from "luxon";

export default {
  name: "details-room-with-desks",
  components: {
    DesksList,
    DetailsRoom,
    PlanCanvas,
    NotificationMessage,
  },
  props: {
    desk: null,
    editMode: null,
  },
  data: () => ({
    pathPartialCap: mdiArrowCollapse,
    pathFullCap: mdiAccountGroup,
    pathDesks: mdiDesk,
    planConfigs: [PlanAdminConfig, PlanUserConfig],
    planConfigIndex: 1,
  }),
  computed: {
    ...mapGetters("centerModule", { centers: "getCenters" }),
    ...mapGetters("roomModule", {
      rooms: "getRooms",
      roomById: "getRoomById",
    }),
    ...mapGetters("deskModule", {
      desksByRoomId: "getDesksByRoomId",
      availableDesksByRoom: "getAvailableDesksByRoom",
    }),
    ...mapGetters("bookingModule", ["getRoomDesksBookedOnInterval"]),
    center() {
      return this.centers.find((x) => x.id == this.$route.params.id);
    },
    room() {
      return this.roomById(parseInt(this.$route.params.roomId));
    },
    desks() {
      return this.desksByRoomId(this.room.id);
    },
    centerTooltip() {
      return this.$t("crudRooms.redirect");
    },
    //roomTooltip() {
    //return this.$t("crudRooms.subscribeToThisRoom");
    //},
    planConfig() {
      return this.planConfigs[this.planConfigIndex];
    },
    allDesks() {
      return this.desks.filter((desk) => desk.deskType == "DESK");
    },

    allEquipments() {
      return this.desks.filter((desk) => desk.deskType == "EQUIPMENT");
    },
    availableDesks() {
      return this.availableDesksByRoom(this.room);
    },
    bookInterval() {
      const day = new DateTime(DateTime.now());
      const interval = new Interval.fromDateTimes(
        DateTime.local(day.year, day.month, day.day, 9),
        DateTime.local(day.year, day.month, day.day, 18)
      );
      return interval;
    },
    bookedDesks() {
      if (!this.bookInterval) return undefined;
      return this.getRoomDesksBookedOnInterval(
        this.room,
        this.availableDesks,
        this.bookInterval
      );
    },
    getDesksAvailable() {
      const getDesks = this.desks.filter((desk) => desk.deskType == "DESK");
      this.desksAvailable = getDesks.length - this.bookedDesks.desks.size;
      return this.desksAvailable;
    },
  },
  methods: {
    ...mapActions("roomModule", ["loadRoomsWithDependents"]),
    ...mapActions("deskModule", ["loadDesksWithDependents"]),
    ...mapActions("deskSlotModule", ["loadDeskSlotsWithDependents"]),
    ...mapActions("userModule", ["loadUsersWithDependents"]),
    ...mapActions("bookingModule", ["loadBookingsWithDependents"]),

    redirectToCenterDetails() {
      this.$router.go(-1);
    },
  },
  async mounted() {
    await this.loadUsersWithDependents();
    await this.loadRoomsWithDependents();
    await this.loadDesksWithDependents();
    await this.loadDeskSlotsWithDependents();
    await this.loadBookingsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  justify-content: center;
}
.notification {
  position: absolute;
  padding: 0 1.5rem;
  z-index: 100;
}
.parent {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  .div1 {
    grid-area: 1 / 1 / 2 / 6;
  }
  .div2 {
    grid-area: 2 / 1 / 7 / 4;

    .scrolling-plan {
      overflow-x: auto;
      overflow-y: auto;
    }
    .list-item-title-place {
      user-select: none;
      padding: 10px;
      margin: 10px;
      align-content: center;
      justify-content: center;
      display: flex;
    }
  }

  .div3 {
    grid-area: 2 / 4 / 7 / 6;
  }
}
</style>
